export const getManageMenuSelectedKey = ({pathname, hash}) => {
    if(pathname.endsWith('/manage/configurable-entities') && hash === '#metadata-entities') {
        return 'metadata-entities';
    }

    const pathSegments = pathname.split('/').filter(Boolean);
    const manageIndex = pathSegments.lastIndexOf('manage');

    return manageIndex === -1 ?
        pathSegments[pathSegments.length - 1] :
        pathSegments[manageIndex + 1];
}
